import StringInput from "components/Atoms/StringInput"
import React, { useCallback } from "react"
import { readableHour } from "utils/date-utils"
import useDCStore from "./dc.store"
import styles from "./dc.module.scss"
import StaticSelector from "components/Atoms/StaticSelector"
import { ESTIMATED_DELIVERY_DAYS } from "data/static.items"
import CustomTimePicker from "components/Atoms/CustomTimePicker"
import { startCase } from "lodash-es"
const TimeslotThreshold = ({ path = "deliverySlots", type = "delivery" }) => {
  const timeslots = useDCStore(
    useCallback(store => store.state.operationalSlots[path], [path])
  )
  const onChange = useDCStore(store => store.setData("operationalSlots"))

  return (
    <table className={styles.timeSlotTable}>
      <thead>
        <tr>
          <th>{startCase(type)} Slot</th>
          <th>Threshold Time (Cutoff Time)</th>
          <th>Estimated {startCase(type)} Days</th>
          <th>Maximum orders for {type}</th>
        </tr>
      </thead>
      <tbody>
        {timeslots?.map((ds, idx) => {
          const hour = ds?.slots?.map?.(h => readableHour(h))?.join("-")
          const removeMargin = idx === timeslots.length - 1 && "mb-0"
          return (
            <tr key={idx}>
              <td>{hour} </td>
              <td>
                <CustomTimePicker
                  value={ds?.thresholdFrom}
                  path={`${path}.${idx}.thresholdFrom`}
                  onChange={onChange}
                />
              </td>
              <td>
                <StaticSelector
                  big={false}
                  items={ESTIMATED_DELIVERY_DAYS}
                  className={removeMargin}
                  path={`${path}.${idx}.estimatedDelivery`}
                  onChange={onChange}
                  value={ds?.estimatedDelivery}
                />
              </td>
              <td>
                <StringInput
                  className={removeMargin}
                  path={`${path}.${idx}.maximumOrders`}
                  type="number"
                  big={false}
                  onChange={onChange}
                  value={ds?.maximumOrders}
                />
              </td>
            </tr>
          )
        })}
      </tbody>
    </table>
  )
}

export default TimeslotThreshold
